import React, { useEffect, useRef } from 'react';
import { SwipeableDrawer } from '@material-ui/core';
import cn from 'classnames';
import { ChevronLeft } from "../../icons";
import { useStateInRef } from "../../utils/useStateInRef";
import { CloseButton } from "../CloseButton/CloseButton";
import { IconButton } from "../IconButton";
import { useOverlayContext } from "../OverlayContext";
import styles from "./BottomSheet.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BottomSheet(props) {
  const {
    open,
    onClose,
    onOpen = () => {},
    children,
    showBackButton,
    maxHeight,
    onBack,
    onExited
  } = props;
  const getProps = useStateInRef(props);
  const {
    isTestMode
  } = useOverlayContext();
  const contentRef = useRef(null);
  useEffect(() => {
    const disableSwipeIfInContent = e => {
      if (getProps().open && contentRef.current && e.target && contentRef.current.contains(e.target)) {
        // This tells MUI SwipeableDrawer to not handle the swipe.
        e['muiHandled'] = true;
      }
    };
    document.addEventListener('touchstart', disableSwipeIfInContent, true);
    return () => {
      document.removeEventListener('touchstart', disableSwipeIfInContent);
    };
  }, []);
  return /*#__PURE__*/_jsxs(SwipeableDrawer, {
    disableDiscovery: true,
    disableSwipeToOpen: true,
    classes: {
      paper: cn(styles.paper, {
        [styles.maxHeight]: maxHeight
      })
    },
    anchor: "bottom",
    open: open,
    onClose: onClose,
    onOpen: onOpen,
    transitionDuration: isTestMode ? 0 : undefined,
    SlideProps: {
      onExited
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [showBackButton && /*#__PURE__*/_jsx("div", {
        className: styles.backButton,
        children: /*#__PURE__*/_jsx(IconButton, {
          onClick: onBack,
          size: "medium",
          "data-testid": "bottom-sheet-back-button",
          children: /*#__PURE__*/_jsx(ChevronLeft, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.swipeIndicator
      }), /*#__PURE__*/_jsx(CloseButton, {
        className: styles.closeButton,
        size: "medium",
        onClick: onClose,
        "data-testid": "bottom-sheet-close-button"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      ref: contentRef,
      children: children
    })]
  });
}